import React from 'react';

const AssignTask = React.lazy(() => import('pages/AssignTask/AssignTask'));
const AssignTaskAll = React.lazy(() => import('pages/AssignTask/AssignTaskAll'));
const AssignTaskAdd = React.lazy(() => import('pages/AssignTask/AssignTaskAdd'));
const AssignTaskEdit = React.lazy(() => import('pages/AssignTask/AssignTaskEdit'));
const AssignTaskDetail = React.lazy(() => import('pages/AssignTask/AssignTaskDetail'));
const AssignTaskReport = React.lazy(() => import('pages/AssignTaskReport/AssignTaskReport'));

const assignTaskRoutes = [
  {
    path: '/assign-task',
    exact: true,
    name: 'Danh sách công việc',
    function: 'ASSIGN_TASK_VIEW',
    component: AssignTask,
  },
  {
    path: '/assign-task-all',
    exact: true,
    name: 'Danh sách công việc admin',
    function: 'ASSIGN_TASK_VIEW_ALL',
    component: AssignTaskAll,
  },
  {
    path: '/assign-task/report',
    exact: true,
    name: 'Báo cáo hiệu suất công việc',
    function: 'ASSIGN_TASK_VIEW',
    component: AssignTaskReport,
  },
  {
    path: '/assign-task/add',
    exact: true,
    name: 'Thêm mới công việc',
    function: 'ASSIGN_TASK_ADD',
    component: AssignTaskAdd,
  },
  {
    path: '/assign-task/detail/:id',
    exact: true,
    name: 'Chi tiết công việc',
    function: 'ASSIGN_TASK_VIEW',
    component: AssignTaskDetail,
  },
  {
    path: '/assign-task/edit/:id',
    exact: true,
    name: 'Chỉnh sửa công việc',
    function: 'ASSIGN_TASK_EDIT',
    component: AssignTaskEdit,
  },
];

export default assignTaskRoutes;
